import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import ExportDialog from '../exportDialog.tsx'
import { useTranslation } from 'react-i18next'
import { Daycare } from '@/types/Daycare'
import { ExportDataType } from '@/types/Export.ts'

interface ExportTaskNotesProps {
    daycares: Daycare[]
    minDate: string
    isRpeOrLaep: boolean
}

const ExportTaskNotes: FunctionComponent<ExportTaskNotesProps> = ({
    daycares,
    minDate,
    isRpeOrLaep
}: ExportTaskNotesProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{t('tasksAndNotes')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.TaskNotes}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={minDate}
                    isRpeOrLaep={isRpeOrLaep}
                />
            )}
        </>
    )
}

export default ExportTaskNotes
